<template>
  <div class="login-container">
    <login :service="true">服务商登录</login>
    <div class="wty-dialog" v-show="dialog_show">
      <div v-if="list_show">
        <div class="wty-dialog-title" style="">
          登录成功，请选择管理的服务商账号
        </div>
        <div class="wty-dialog-body">
          <div style="margin-bottom:10px;">您可以登录的后台有：</div>
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 460px;">
            <!-- background-color: rgb(77, 255, 0); -->
            <div style="">
              <div class="body-main">
                <div
                  @click="checkedService(item)"
                  class=""
                  v-for="(item, index) in service_list"
                  :key="index"
                  :class="
                    service_no == item.service_no
                      ? 'body-main-item-checked'
                      : 'body-main-item'
                  "
                >
                  <div class="item-label">{{ item.service_no }}：</div>

                  <div class="item-value">{{ item.service_name }}</div>
                </div>
              </div>
            </div>
          </el-scrollbar>
          <div class="wty-dialog-footer">
            <div class="footer-item" @click="showDialog(false)">取消</div>
            <div class="footer-item" @click="dialogSureClick">确定</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="wty-dialog-title" style="">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import login from "../components/login.vue";
import { getlistServiceProvider } from "@/api/login.js";
import { mapMutations } from "vuex";
export default {
  inject: ["reload"],
  provide() {
    return {
      showDialog: this.showDialog
    };
  },
  components: { login },
  data() {
    return {
      title: "",
      list_show: true,
      dialog_show: false,
      service_no: "",
      service_name: "",
      service_list: []
    };
  },
  async created() {},
  beforeMount() {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS"]),
    dialogSureClick() {
      localStorage.setItem("service_no", this.service_no);
      localStorage.setItem("service_name", this.service_name);
      this.UPDATEMENUTABS("/welcome");
      this.$router.push("/welcome");
      this.successMessage("服务商系统登录成功！！！");
    },
    async showDialog(key) {
      console.log("服务商-------showDialog");
      if (key) {
        const res = await getlistServiceProvider();
        if (this.testR(res)) {
          if (res.data.resp_data.length > 0) {
            this.service_list = res.data.resp_data;
            if (this.service_list.length === 1) {
              this.service_no = this.service_list[0].service_no;
              this.service_name = this.service_list[0].service_name;
              this.dialogSureClick();
            }
            this.dialog_show = true;
          } else {
            this.warnMessage("未发现可登录的服务商后台");
          }
        }
      } else {
        this.dialog_show = false;
      }
    },
    checkedService(value) {
      console.log("value------------", value);
      if (value.service_no === this.service_no) {
        this.service_no = "";
        this.service_name = "";
        return;
      }
      this.service_no = value.service_no;
      this.service_name = value.service_name;
    },
    optionShow() {},
    getGroupPermission() {}
  }
};
</script>
<style lang="less" scoped>
.login-container {
  background-color: #2b4b6b;
  background: url(../assets/pic/0001.jpg);
  background-position: center;
  background-attachment: fixed;
  background-size: 105% auto;
  height: 100%;
}
.wty-dialog {
  // display: ;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(1, 1, 1, 0.8);
  z-index: 2003;
  display: flex;
  .wty-dialog-title {
    position: fixed;
    top: 50px;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    font-weight: 700;
    font-size: 40px;
    color: #fff;
    text-align: center;
    z-index: 2004;
  }
  .wty-dialog-body {
    position: fixed;
    width: 800px;
    height: 550px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background-color: rgba(255, 255, 255, 0.8);
    z-index: 2004;
    font-size: 24px;
    // font-weight: 700;
    color: #fff;
    .body-main {
      width: 100%;
      padding: 0 20px;
      .body-main-item {
        height: auto;
        padding: 20px;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.4);
        margin: 10px 0;
        display: flex;
        color: #409eff;
        .item-label {
          width: 200px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }
        .item-value {
          width: 500px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }
      }
      .body-main-item:hover {
        background-color: rgba(0, 0, 0, 0.5);
        font-weight: 700;
        color: #fff;
      }
      .body-main-item-checked {
        background: #409eff;
        font-weight: 700;
        color: #fff;
        height: auto;
        padding: 20px;
        cursor: pointer;
        margin: 10px 0;
        display: flex;
        .item-label {
          width: 200px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
        }
      }
      // height: 60px;
    }
  }
  .wty-dialog-footer {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    margin-top: 10px;
    .footer-item {
      width: auto;
      font-size: 30px;
      padding: 0 40px;
      cursor: pointer;
      font-weight: 700;
    }
    .footer-item:hover {
      color: #0280ff;
    }
  }
}
</style>
